<template>
  <div>
    <q-form
      ref="newComment"
      :model="newComment"
      :rules="rules"
      label-width="120px"
    >
      <q-form-item
        v-if="this.$store.state.session.sessionId === 'GUEST'"
        :label="this.$qt('post.comment.rules.name.text')"
        prop="name"
      >
        <q-input v-model="newComment.name" />
      </q-form-item>

      <q-form-item
        :label="this.$qt('post.comment.rules.phone.text')"
        prop="phone"
      >
        <q-input v-model="newComment.phone" />
      </q-form-item>

      <q-form-item
        :label="this.$qt('post.comment.rules.email.text')"
        prop="email"
      >
        <q-input v-model="newComment.email" />
      </q-form-item>

      <q-form-item
        :label="this.$qt('post.comment.rules.note.text')"
        prop="note"
      >
        <q-input
          v-model="newComment.note"
          :rows="7"
          type="textarea"
        />
      </q-form-item>

      <q-form-item>
        <q-button
          type="primary"
          @click="submitForm('newComment')"
        >
          {{ this.$qt('post.comment.sendButtonText') }}
        </q-button>
        <q-button @click="resetForm('newComment')">
          {{ this.$qt('post.comment.resetButtonText') }}
        </q-button>
      </q-form-item>
    </q-form>
  </div>
</template>

<script>
  export default {
    name: "AddComment",

    props: {
      postId: {
        required: true
      }
    },


    data() {
      return {
        newComment: {
          name: '',
          phone: '',
          email: '',
          note: ''
        },
        rules: {
          name: [
            { required: true, message: this.$qt('post.comment.rules.name.requiredMessage'), trigger: 'blur' },
            { min: 3, max: 5, message: this.$qt('post.comment.rules.name.min_maxMessage'), trigger: 'blur' }
          ],
          phone: [
            { required: true, message: this.$qt('post.comment.rules.phone.requiredMessage'), trigger: 'change' }
          ],
          email: [
            { required: true, message: this.$qt('post.comment.rules.email.requiredMessage'), trigger: 'change' }
          ],
          note: [
            { required: true, message: this.$qt('post.comment.rules.note.requiredMessage'), trigger: 'blur' }
          ]
        }
      };
    },

    methods: {
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$delegate('edms', 'addCommentToPost', {
              postId: this.postId,
              newComment: this.newComment
            }).then((res) => {
              this.$notify({
                title: this.$qt('post.comment.addSuccessMessage'),
                message: res.message,
                type: 'success'
              });
              this.$message({
                type: 'success',
                message: this.$qt('post.comment.addSuccessMessage')
              });
              this.$emit('comment-added', res.result.comments);
              this.newComment = {
                name: '',
                  phone: '',
                  email: '',
                  note: ''
              };
            }).catch((err) => {
              this.$message({
                type: 'warning',
                message: err
              });
            });
          } else {
            this.$notify({
              title: this.$qt('notify.warningTitle'),
              message: this.$qt('validation.completeFormMessage'),
              type: 'warning'
            });
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  }
</script>

<style scoped>

</style>